import isEmpty from 'lodash/isEmpty';
import store from '../store';
import {getCovers} from "@/api/books";
import {isArray} from 'lodash';
import {useRoute} from "vue-router";

/**
 * 获取随机图书封面
 */
function randomBookCover() {
    return require(`@/assets/img/bookCover/${pickOneFromNum(20)}.jpg`);
}

/**
 * 产生一个[1, num]的伪随机数
 */
function pickOneFromNum(num) {
    return Math.floor(Math.random() * num) + 1;
}

/**
 * 检查 value 是否为一个空对象，集合，映射或者set。 判断的依据是除非是有枚举属性的对象，length 大于 0 的 arguments object, array, string 或类jquery选择器。
 * 对象如果被认为为空，那么他们没有自己的可枚举属性的对象。
 * 类数组值，比如arguments对象，array，buffer，string或者类jQuery集合的length 为 0，被认为是空。类似的，map（映射）和set 的size 为 0，被认为是空
 */
function isNotEmpty(val) {
    return !isEmpty(val);
}

/**
 * 判断是否为非空数组
 */
function isNotEmptyArray(arr) {
    return isArray(arr) && !isEmpty(arr);
}

/**
 * 批量获取封面
 *  * type= 0: list是正常数组，1: list是经过chunk处理的 2 book在list内部
 */
function setCovers(isbns, list, type = 0) {
    getCovers(isbns)
        .then(data => {
            if (isNotEmpty(data)) {
                handleCovers(data, list, type);
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

/**
 * 处理封面数据
 * type= 0: list是正常数组，1: list是经过chunk处理的 2 book在list内部
 */
function handleCovers(data, list, type) {
    Object.keys(data).forEach(item => {
        if (isNotEmpty(data[item])) {
            let imageUrl = '';
            data[item].forEach((i) => {
                if (i.imageUrl) {
                    imageUrl = i.imageUrl;
                }
            });
            if(imageUrl) {
                if (type === 1) {
                    list.forEach((v) => {
                        const index = v.findIndex((temp) => temp.isbn === item);
                        if (index !== -1 && isEmpty(v[index].coverUrl)) {
                            Object.assign(v[index], {coverUrl: imageUrl});
                        }
                    })
                } else if (type === 0) {
                    const index = list.findIndex((temp) => temp.isbn === item);
                    if (index !== -1 && isEmpty(list[index].coverUrl)) {
                        Object.assign(list[index], {coverUrl: imageUrl});
                    }
                } else {
                    const index = list.findIndex(temp => {
                        if (isNotEmpty(temp.book)) {
                            return temp.book.isbn === item;
                        }
                    });
                    if (index !== -1 && isEmpty(list[index].coverUrl)) {
                        Object.assign(list[index].book, {coverUrl: imageUrl});
                    }
                }
            }
        }
    })
}

/**
 * 处理购物车封面数据 list是一个数组{vendorName:key,books:data[key]}
 */
function setCoversCart(isbns, list = []) {
    getCovers(isbns)
        .then(data => {
            if (isNotEmpty(data)) {
                Object.keys(data).forEach(item => {
                    if (isNotEmpty(data[item])) {
                        let imageUrl = '';
                        data[item].forEach(i => {
                            if (i.imageUrl) {
                                imageUrl = i.imageUrl;
                            }
                        });
                        if (imageUrl) {
                            if (isNotEmpty(list)) {
                                list.forEach(item => {
                                    const index = item.books.findIndex(temp => {
                                        if (isNotEmpty(temp.pdaBook)) {
                                            return temp.pdaBook.isbn === item;
                                        }
                                    });
                                    if (index !== -1 && isEmpty(item.books[index].pdaBook.coverUrl)) {
                                        Object.assign(item.books[index].pdaBook, {coverUrl: imageUrl});
                                    }
                                })
                            }
                        }
                    }
                })
            }
        })
        .catch((error) => {
            console.error(error);
        });
};

/**
 * 登录拦截
 */
function loginInterceptor(path) {
    const uid = store.state.reader.user.uid;
    if (uid) {
        // 已登录
        return true;
    } else {
        let url = store.state.baseConfig['pda.start.url'] ?? store.state.config['pda.start.url'];
        // 替换当前页面 因为已经进入到需要登录的页面
        window.location.replace(url + path);
    }
}

// 获取馆藏链接
function getLibLink(link) {
    let url = store.state.baseConfig['pda.search.url'] ?? store.state.config['pda.search.url'];
    return url + link;
}
/**
 * 判断是pc端还是手机端
 */
function isMobile() {
    return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
}
function doLogout(){
    let url = store.state.baseConfig['pda.logout.url'] ?? store.state.config['pda.logout.url'];
    store.commit('setUser', {});
    store.commit('setInstitution', '');
    store.commit('setCartNum', '');
    store.commit('addToken', '');
    setTimeout(() => {
        window.open(url, '_self');
    }, 3000)
}
export {
    randomBookCover,
    pickOneFromNum,
    isNotEmpty,
    isNotEmptyArray,
    setCovers,
    setCoversCart,
    loginInterceptor,
    getLibLink,
    isMobile,
    doLogout
}
